const DEFAULT_CONFIG = {
    cinemaLeftLateralSpace: 16,
    marginBetweenTiles: 8,
    defaultNumberOfTiles: 5,
    clusters: [
        {
            belongs: (width) => width <= 497,
            tiles: 2,
        },
        {
            belongs: (width) => 497 < width && width <= 636,
            tiles: 3,
        },
        {
            belongs: (width) => 636 < width && width <= 767,
            tiles: 4,
        },
    ],
};

export const calculateTileDimension = (
    cinemaInjectionContainerWidth,
    { cinemaLeftLateralSpace, defaultNumberOfTiles, marginBetweenTiles, clusters } = DEFAULT_CONFIG
) => {
    const numberOfVisibleTiles = calculateNumberOfVisibleTiles(cinemaInjectionContainerWidth, defaultNumberOfTiles, clusters);
    const cinemaAvailableSpace = cinemaInjectionContainerWidth - cinemaLeftLateralSpace;
    const totalNumberOfVisibleTiles = numberOfVisibleTiles + 0.5;

    const totalMarginForVisibleTiles = numberOfVisibleTiles * marginBetweenTiles;

    const width = (cinemaAvailableSpace - totalMarginForVisibleTiles) / totalNumberOfVisibleTiles;
    const height = (4 / 3) * width;

    return {
        width,
        height,
        numberOfVisibleTiles,
    };
};

const calculateNumberOfVisibleTiles = (cinemaAvailableSpace, defaultNumberOfTiles, clusters) => {
    const cluster = clusters.find(({ belongs }) => belongs(cinemaAvailableSpace));
    return cluster ? cluster.tiles : defaultNumberOfTiles;
};
